import { css } from '@emotion/react';
import colors from 'config/color';

export const containerStyles = css`
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  height: 80px;
  margin: 0 0 40px;
  background: ${colors.WHITE};
`;

export const contentContainerStyles = css`
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
  height: calc(100% - 36px);
`;

export const navigationContainerStyles = css`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const buttonContainerStyles = css`
  display: flex;

  button {
    color: ${colors.WHITE};
    width: 250px;

    &:first-of-type {
      margin: 0 20px 0 0;
      background: ${colors.WHITE};
      color: ${colors.PRIMARY_YELLOWISH_ORANGE};
      border-color: ${colors.PRIMARY_YELLOWISH_ORANGE};
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
      letter-spacing: -0.01em;
      width: 150px;
    }
  }
`;

export const textStyles = css`
  color: ${colors.BLUE};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: -0.01em;
`;

export const navlinkContainerStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-bottom: 1px solid ${colors.WHITE};
  margin: 0 16px;

  span {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
    color: ${colors.SECONDARY_BLACK};
  }
`;

export const postJobButtonStyles = css`
  width: 200px;
  font-weight: 500;
`;
